import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Table } from 'primeng/table';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { ConfirmationService, Message, SelectItem } from 'primeng/api';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { ContratoService } from 'src/app/admihair/service/contrato.service';
import { Contrato } from 'src/app/admihair/api/dto/contrato';
import { AuthUtil } from 'src/app/admihair/util/auth-util';
import { AdmihairBaseComponent } from '../../../admihair-base.component';


@Component({
  selector: 'app-contrato-listar',
  templateUrl: './contrato-listar.component.html',
  styleUrls: ['./contrato-listar.component.scss']
})
export class ContratoListarComponent extends AdmihairBaseComponent implements OnInit {

  loading: boolean = false;
  loadingContratos: boolean = false;
  situacoesStatus: SelectItem[] = [{ label: 'ATIVOS', value: true }, { label: 'INATIVOS', value: false }];
  statusSelecionado: boolean = true;
  contratos: Contrato[] = [];

  constructor(private contratoService: ContratoService,
    private confirmationService: ConfirmationService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    utilStorageService: UtilStorageService,
    erroService: ErroService) {
    super(erroService, utilStorageService)
  }


  @ViewChild('filter') filter!: ElementRef;

  ngOnInit(): void {
    this.loadingContratos = true;
    this.permissaoListar = this.verificarPermissao('PERM_LISTAR_CONTRATO');
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_CONTRATO');
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_CONTRATO');
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_CONTRATO');
    this.permissaoExcluir = this.verificarPermissao('PERM_EXCLUIR_CONTRATO');
    if (this.permissaoListar) {
      this.listarContratos();
    }
  }

  listarContratos() {
    const empresaSelecionada: Empresa = this.getEmpresa();
    const tipoContrato = 1;
    this.contratoService.listarPorEmpresaIdETipoESituacao(
      empresaSelecionada.id,
      tipoContrato,
      this.statusSelecionado
    ).subscribe({
      next: (data: Contrato[]) => {
        this.loadingContratos = false;
        this.contratos = data;
      },
      error: (error: any) => {
        this.loadingContratos = false;
        this.exibirMensagemErro(error)
      }
    })
  }

  excluir(contratoId: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.contratoService.excluir(contratoId).subscribe({
          next: () => {
            this.listarContratos();
            this.exibirMensagemSucesso();
          },
          error: (error: any) => {
            this.exibirMensagemErro(error)
          }
        });
      }
    });
  }


  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  editarContrato(id: number) {
    this._router.navigate(["/apps/contrato/editar/" + id], { relativeTo: this._activatedRoute })
  }

  detalharContrato(id: number) {
    this._router.navigate(["/apps/contrato/detalhar/" + id], { relativeTo: this._activatedRoute })
  }


}
